/**
 * @generated SignedSource<<b042fdab979b5d6331f97d976f8eac53>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type TodoTimelineUpdateEventTag_tag$data = {
  readonly color: string;
  readonly title: string;
  readonly " $fragmentType": "TodoTimelineUpdateEventTag_tag";
};
export type TodoTimelineUpdateEventTag_tag$key = {
  readonly " $data"?: TodoTimelineUpdateEventTag_tag$data;
  readonly " $fragmentSpreads": FragmentRefs<"TodoTimelineUpdateEventTag_tag">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "TodoTimelineUpdateEventTag_tag",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "color",
      "storageKey": null
    }
  ],
  "type": "TodoCategoryTag",
  "abstractKey": null
};

(node as any).hash = "4e34553248affe075594975f277bb8b4";

export default node;
